/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-unescaped-entities */

import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import notifications from "../../assets/json/notifications";
import { Applogo, Avatar_02 } from "../../Routes/ImagePath/index";
import { logout } from "../../utils/auth";
import { axiosInstance } from "../../helper/Axios/axios";
import {
  loggedInUser,
  patient as patientEndpoint,
} from "../../helper/endpoints/api_endpoints";

import {
  FaRegBell,
  FaSearch,
  FaChevronDown,
  FaBars,
  FaUserPlus,
} from "react-icons/fa";
import { useLocation } from "react-router-dom/dist";
import { Dropdown } from "react-bootstrap";
import { Spin } from "antd";

const Header = (props) => {
  const data = notifications.notifications;
  const [notification, setNotifications] = useState(false);
  const [profile, setProfile] = useState(false);
  const [isMiniSidebar, setIsMiniSidebar] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [openMobileMenu, setOpenMobileMenu] = useState(false);
  const navigate = useNavigate();
  const [userDetails, setUserDetails] = useState(null);
  const [searchResults, setSearchResults] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const searchTimeout = React.useRef();
  const [logoutLoading, setLogoutLoading] = useState(false);

  // Function to generate UI Avatar URL
  const getAvatarUrl = (name) => {
    const firstLetter = name ? name.charAt(0).toUpperCase() : "U";
    return `https://ui-avatars.com/api/?name=${firstLetter}&background=11998e&color=fff&size=128&font-size=0.5`;
  };

  // Get user info from Redux store with enhanced details
  const {
    email,
    designation,
    firstName,
    lastName,
    avatar,
    role,
    isLoaded,
    error,
  } = useSelector((state) => state.user);

  // Fetch user details from API
  const fetchUserDetails = async () => {
    try {
      const res = await axiosInstance.get(loggedInUser);
      setUserDetails(res.data);
      localStorage.setItem("userDesignation", res.data.designation);
    } catch (err) {
      if (
        err.response &&
        (err.response.status === 404 ||
          err.response.status === 401 ||
          err.response.status === 403)
      ) {
        await logout();
        navigate("/");
      }
    }
  };

  useEffect(() => {
    fetchUserDetails();
    // Listen for tab activity
    const handleVisibility = () => {
      if (document.visibilityState === "visible") {
        fetchUserDetails();
      }
    };
    document.addEventListener("visibilitychange", handleVisibility);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibility);
    };
  }, []);

  // Compute display name
  const displayName =
    userDetails?.name ||
    (userDetails?.user?.email
      ? userDetails.user.email.split("@")[0].charAt(0).toUpperCase() +
        userDetails.user.email.split("@")[0].slice(1)
      : "User");

  useEffect(() => {
    // Check if mini-sidebar class is already present
    if (document.body.classList.contains("mini-sidebar")) {
      setIsMiniSidebar(true);
    }
  }, []);

  const handlesidebar = () => {
    const newState = !isMiniSidebar;
    setIsMiniSidebar(newState);
    document.body.classList.toggle("mini-sidebar");
  };

  const onMenuClik = () => {
    document.body.classList.toggle("slide-nav");
  };

  // Function to handle mobile sidebar toggle specifically
  const handleMobileSidebar = () => {
    // For mobile, we should use the slide-nav class instead of mini-sidebar
    document.body.classList.toggle("slide-nav");
    // You might still want to track the state
    setIsMiniSidebar(!isMiniSidebar);
  };

  const handleNotification = () => {
    setNotifications(!notification);
    setProfile(false);
  };

  const handleProfile = () => {
    setProfile(!profile);
    setNotifications(false);
  };

  // Patient search handler
  const handleSearchChange = async (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    if (searchTimeout.current) clearTimeout(searchTimeout.current);
    if (!value) {
      setSearchResults([]);
      setShowDropdown(false);
      return;
    }
    setSearchLoading(true);
    searchTimeout.current = setTimeout(async () => {
      try {
        const res = await axiosInstance.get(patientEndpoint, {
          params: { search: value, page: 1 },
        });
        setSearchResults(res.data.results || []);
        setShowDropdown(true);
      } catch (err) {
        setSearchResults([]);
        setShowDropdown(false);
      } finally {
        setSearchLoading(false);
      }
    }, 350);
  };

  // Handle patient selection
  const handlePatientSelect = (patient) => {
    setSearchTerm("");
    setSearchResults([]);
    setShowDropdown(false);
    navigate(`/patient-details/${patient.id}`);
  };

  // Hide dropdown on click outside
  React.useEffect(() => {
    const handleClick = (e) => {
      if (!e.target.closest(".header-search-autocomplete")) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  const toggleMobileMenu = () => {
    setOpenMobileMenu(!openMobileMenu);
  };

  const location = useLocation();
  let pathname = location.pathname;

  // Header styles - restored to original with fixed positioning
  const headerStyle = {
    background: "white",
    padding: "10px 20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: "60px",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1002,
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  };

  const logoContainerStyle = {
    display: "flex",
    alignItems: "center",
  };

  const logoStyle = {
    height: "40px",
    width: "40px",
    objectFit: "contain",
    marginRight: "10px",
  };

  const logoTextStyle = {
    fontSize: "18px",
    color: "#000",
    margin: 0,
  };

  // Updated search container style - smaller and to the left
  const searchContainerStyle = {
    display: "flex",
    alignItems: "center",
    width: "300px", // Reduced width
    marginLeft: "20px", // Positioned after toggle
    position: "relative",
    border: "2px solid transparent",
    borderRadius: "30px",
    background:
      "linear-gradient(white, white) padding-box, linear-gradient(90deg, #FDD789, #C3EBE5, #E0BBED, #F784A7) border-box",

    // Hide on mobile
    "@media (max-width: 768px)": {
      display: "none",
    },
  };

  const searchInputStyle = {
    width: "100%",
    padding: "8px 15px 8px 35px", // Keep left icon space
    borderRadius: "30px",
    border: "none",
    backgroundColor: "#fff",
    fontSize: "12px",
    outline: "none",
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.05)",
    height: "35px",
  };

  const searchIconStyle = {
    position: "absolute",
    left: "12px",
    color: "#999",
    fontSize: "14px",
    top: "50%",
    transform: "translateY(-50%)",
  };

  // Updated search button style for better alignment
  const searchButtonStyle = {
    position: "absolute",
    right: "4px", // Slightly adjusted right position
    top: "50%",
    transform: "translateY(-50%)", // Center vertically
    padding: "0 15px", // Horizontal padding only
    borderRadius: "20px",
    border: "none",
    backgroundColor: "#ED8A9C",
    color: "white",
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: "500",
    height: "27px", // Fixed height
    lineHeight: "27px", // Match height for vertical centering
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  // Update user profile section
  const userProfileStyle = {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    padding: "5px 12px",
    borderRadius: "30px",
    border: "1px solid #11998e",
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    color: "#11998e",
    marginLeft: "auto",
  };

  const avatarStyle = {
    width: "32px",
    height: "32px",
    borderRadius: "50%",
    marginRight: "10px",
    backgroundColor: "#ddd",
    border: "1px solid #9BDDD5",
    backgroundImage: `url(${getAvatarUrl(displayName)})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  };

  const userNameStyle = {
    fontSize: "14px",
    fontWeight: "500",
    marginRight: "8px",
    color: "#11998e",
  };

  // Style for toggle button
  const toggleBtnStyle = {
    marginLeft: "15px",
    color: "#11998e",
    display:
      pathname.includes("tasks") || pathname.includes("compose")
        ? "none"
        : "block",
  };

  // Mobile menu toggle button style
  const mobileMenuToggleStyle = {
    display: "none",
    color: "#11998e",
    fontSize: "24px",
    marginLeft: "auto",
    cursor: "pointer",
    "@media (max-width: 768px)": {
      display: "block",
    },
  };

  // Mobile menu style
  const mobileMenuStyle = {
    display: openMobileMenu ? "block" : "none",
    position: "absolute",
    top: "55px",
    right: "0",
    backgroundColor: "white",
    width: "200px",
    boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
    borderRadius: "0 0 10px 10px",
    zIndex: 1000,
  };

  const handleLogout = async () => {
    try {
      setLogoutLoading(true);
      const result = await logout();
      if (result.success) {
        // Close the profile dropdown
        setProfile(false);
        // Navigate to login page
        navigate("/");
      } else {
        // If there's an error message from the API, show it
        console.error("Logout failed:", result.error);
        // You might want to show this error to the user in a more user-friendly way
      }
    } catch (error) {
      console.error("Logout error:", error);
      // Handle any unexpected errors during logout
    } finally {
      setLogoutLoading(false);
    }
  };

  return (
    <div className="header" style={headerStyle}>
      {/* Left section with logo, toggle and search */}
      <div style={{ display: "flex", alignItems: "center" }}>
        {/* Logo - visible only on desktop */}
        <div style={logoContainerStyle} className="d-none d-md-flex">
          <Link to="/admin-dashboard" className="logo">
            <img
              src="https://www.singhaniaclinic.com/wp-content/uploads/2024/01/IMG_1675-700x700.png"
              alt="Singhania Clinic"
              style={logoStyle}
            />
          </Link>
          <h2 style={logoTextStyle}>Singhania Clinic</h2>
        </div>

        {/* Toggle sidebar button - different handlers for mobile and desktop */}
        <Link
          id="toggle_btn"
          to="#"
          style={{
            ...toggleBtnStyle,
            display:
              pathname.includes("tasks") || pathname.includes("compose")
                ? "none"
                : "block",
          }}
          onClick={
            window.innerWidth < 768 ? handleMobileSidebar : handlesidebar
          }
          className="d-md-block"
        >
          <span
            className="bar-icon"
            style={{ display: "inline-block", paddingTop: "15px" }}
          >
            <span
              style={{
                backgroundColor: "#11998e",
                height: "2px",
                width: "20px",
                display: "block",
                marginBottom: "4px",
              }}
            />
            <span
              style={{
                backgroundColor: "#11998e",
                height: "2px",
                width: "20px",
                display: "block",
                marginBottom: "4px",
              }}
            />
            <span
              style={{
                backgroundColor: "#9BDDD5",
                height: "2px",
                width: "20px",
                display: "block",
              }}
            />
          </span>
        </Link>

        {/* Logo - desktop (full) and mobile (centered) */}
        <div
          style={{
            ...logoContainerStyle,
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            paddingTop: "3px",
          }}
          className="d-block d-md-none"
        >
          <Link to="/admin-dashboard">
            <img
              src="https://www.singhaniaclinic.com/wp-content/uploads/2024/01/IMG_1675-700x700.png"
              alt="Singhania Clinic"
              style={{ width: "35px", height: "35px" }}
            />
          </Link>
        </div>

        {/* Desktop logo (left aligned) */}

        {/* Search Bar - desktop only */}
        <div
          style={searchContainerStyle}
          className="d-none d-md-flex header-search-autocomplete"
        >
          <FaSearch style={searchIconStyle} />
          <form style={{ width: "100%" }} autoComplete="off">
            <input
              type="text"
              placeholder="Search Patient Name /Registration No."
              style={searchInputStyle}
              value={searchTerm}
              onChange={handleSearchChange}
              onFocus={() => searchResults.length > 0 && setShowDropdown(true)}
              autoComplete="off"
            />
            {/* <button type="submit" style={searchButtonStyle}>
              Search
            </button> */}
          </form>
          {showDropdown && searchResults.length > 0 && (
            <div
              style={{
                position: "absolute",
                top: "110%",
                left: 0,
                width: "100%",
                background: "#fff",
                boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
                borderRadius: 8,
                zIndex: 1001,
                maxHeight: 320,
                overflowY: "auto",
              }}
            >
              {searchLoading ? (
                <div
                  style={{ padding: 16, textAlign: "center", color: "#888" }}
                >
                  Searching...
                </div>
              ) : (
                searchResults.map((p) => (
                  <div
                    key={p.id}
                    style={{
                      padding: "10px 18px",
                      cursor: "pointer",
                      borderBottom: "1px solid #f0f0f0",
                      fontSize: 15,
                      color: "#333",
                      background: "#fff",
                    }}
                    onClick={() => handlePatientSelect(p)}
                    onMouseDown={(e) => e.preventDefault()}
                  >
                    <div style={{ fontWeight: 500 }}>{p.name}</div>
                    <div style={{ fontSize: 13, color: "#888" }}>
                      {p.registration_number}
                    </div>
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      </div>

      {/* User Profile - both desktop and mobile */}
      <div style={userProfileStyle} onClick={handleProfile}>
        <div style={avatarStyle}></div>
        <span style={userNameStyle} className="d-none d-md-inline">
          {displayName}
          {userDetails?.designation && (
            <span style={{ fontSize: "12px", color: "#666", display: "block" }}>
              {userDetails.designation}
            </span>
          )}
        </span>
        <FaChevronDown size={12} color="#9BDDD5" />

        {/* User dropdown menu */}
        <div
          className={`dropdown-menu dropdown-menu-end ${profile ? "show" : ""}`}
          style={{
            position: "absolute",
            top: "60px",
            right: "10px",
            zIndex: 1000,
            backgroundColor: "#fff",
            boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
            borderRadius: "10px",
            border: "none",
            width: "200px",
            padding: "10px 0",
            color: "#222",
          }}
        >
          <div
            style={{
              padding: "8px 20px",
              borderBottom: "1px solid #eee",
              marginBottom: "5px",
            }}
          >
            <div style={{ fontWeight: "500" }}>{displayName}</div>
            <div style={{ fontSize: "12px", color: "#666" }}>
              {userDetails?.user?.email}
            </div>
            {userDetails?.designation && (
              <div style={{ fontSize: "12px", color: "#666" }}>
                {userDetails.designation}
              </div>
            )}
          </div>
          <button
            className="dropdown-item"
            onClick={handleLogout}
            style={{
              padding: "8px 20px",
              color: "#222",
              border: "none",
              background: "none",
              width: "100%",
              textAlign: "left",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              opacity: logoutLoading ? 0.7 : 1,
              pointerEvents: logoutLoading ? "none" : "auto",
            }}
            disabled={logoutLoading}
          >
            <i
              className="fas fa-sign-out-alt"
              style={{ marginRight: "10px" }}
            ></i>
            {logoutLoading ? (
              <Spin size="small" style={{ marginRight: 8 }} />
            ) : null}
            Logout
          </button>
        </div>
      </div>

      {/* Add New Patient Button - fixed at the bottom on mobile, normal position on desktop */}
      <div
        className="d-md-none"
        style={{
          position: "fixed",
          right: "15px",
          bottom: "15px",
          zIndex: 999,
        }}
      >
        <Link
          to="/add-patient"
          className="btn btn-primary rounded-circle"
          style={{ width: "50px", height: "50px" }}
        >
          <FaUserPlus />
        </Link>
      </div>
    </div>
  );
};

export default Header;
